<template>
  <section>
    <v-card class="global-card px-5 mt-10 pt-5">
      <v-card-text>
        <v-row>
          <v-col cols="12" class="py-0">
            <v-toolbar flat class="main-header px-0 mb-6">
              <v-toolbar-title class="main-header__title">
                <h2 class="heading-counter my-6">
                  Assign Camps to <small>'{{ form.name }}'</small>
                </h2>
              </v-toolbar-title>

              <v-spacer></v-spacer>
              <v-toolbar-items class="main-header__contents">
                <v-btn
                  class="button btn-height--1 my-auto mx-1"
                  @click="addDiscount"
                  color="success"
                  :disabled="addButtonCheck()"
                >
                  <i class="icon-add"></i>
                  <span class="mx-2">Add Camp</span>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
          </v-col>
          <v-col md="3" sm="6" cols="12">
            <v-autocomplete
              :items="camps"
              label="Camps"
              item-text="name"
              item-value="id"
              v-model="discounts.id"
              @change="campsSelected()"
            ></v-autocomplete>
          </v-col>
          <v-col md="3" sm="6" cols="12">
            <section class="increment-label">
              <span>Discount Value</span>
              <number-input
                center
                v-model="discounts.value"
                :min="0"
                controls
                :step="1"
                :disabled="!form.allow_camp_modify"
              ></number-input>
            </section>
          </v-col>
          <v-col md="3" sm="6" cols="12">
            <v-select
              :items="valueType"
              item-text="text"
              item-value="text"
              label="Value Type"
              regular
              clearable
              v-model="discounts.value_type"
              :disabled="!form.allow_camp_modify"
            ></v-select>
          </v-col>
          <v-col md="3" sm="6" cols="12" class="expiry-date">
            <span>Expiry Date</span>
            <date-time-picker
              v-model.trim="discounts.expiry_date.date"
              :date-time="discounts.expiry_date.date"
              :textFieldProps="{ regular: true }"
              timeFormat="HH:mm:ss"
              :allowedDates="allowedDates"
            ></date-time-picker>
          </v-col>
          <v-col cols="12">
            <v-data-table
              :headers="discounts_headers"
              :items="discounts_added"
              hide-default-footer
              :mobile-breakpoint="0"
              :items-per-page="1000"
              class="table"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td class="text-sm-center">{{ item.name }}</td>
                  <td class="text-sm-center">{{ item.value }}</td>
                  <td class="text-sm-center">{{ item.value_type }}</td>
                  <td class="text-sm-center">
                    <span v-if="item.expiry_date !== ''">{{
                      item.expiry_date
                        ? item.expiry_date.date
                        : "---" | moment("Do MMM'YYYY hh:mm")
                    }}</span>
                    <span v-else>No Expiry Date</span>
                  </td>
                  <td class="text-sm-center">
                    <i
                      class="icon-delete delete"
                      @click="handleDelete(item)"
                    ></i>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row> </v-card-text
    ></v-card>
  </section>
</template>

<script>
import { IndexDataQuery } from "@/helpers/apiMethods";
import TableHeaders from "@/helpers/TableHeaders";

export default {
  data() {
    return {
      camps: [],
      prices: [
        {
          icon: "",
          label: "Bus",
          toggle: "has_bus",
          number_model: "bus_price"
        },
        {
          icon: "",
          label: "Meal",
          toggle: "has_meals",
          number_model: "meal_price"
        }
      ],
      activatedInputs: null,
      valueType: [{ text: "amount" }, { text: "percentage" }],
      discounts_added: [],
      discounts_headers: [],
      menu1: false
    };
  },
  components: {
    DateTimePicker: () => import("@/components/DateTimePicker")
  },
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    discounts: {
      type: Object,
      default: () => {}
    },
    discoutsItems: {
      type: Array,
      default: () => {}
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.indexCamps();
    this.createTableHeaders();
  },
  methods: {
    indexCamps() {
      IndexDataQuery({ reqName: `/camps?a&list_all` })
        .then(res => {
          const { data } = res.data;
          this.camps = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    addDiscount() {
      this.discounts_added.push(this.discounts);
      this.$emit("handle_discounts_added", this.discounts_added);
      this.$emit("handle_reset_discount");
    },
    allowedDates(value) {
      const previesDate = new Date(value);
      const currentDate = new Date(
        new Date().setDate(new Date().getDate() - 1)
      );
      return previesDate > currentDate;
    },
    addButtonCheck() {
      if (this.discounts.id === null) {
        return true;
      } else {
        return false;
      }
    },
    createTableHeaders() {
      const headersList = [
        "Camp Name",
        "Value",
        "Value Type",
        "Expiry Date",
        "Discard"
      ];
      this.discounts_headers = TableHeaders(headersList);
    },
    campsSelected() {
      const camp = this.discounts.id;
      this.camps.forEach(item => {
        if (item.id === camp) {
          this.discounts.name = item.name;
          this.$emit("camp_name", item);
        }
      });
      // this.discounts.push(this.form.value);
      // this.discounts.name = { ...this.form };
      // this.discounts.value = { ...this.form.value };
      // this.discounts.value_type = { ...this.form.value_type };
    },
    handleDelete(item) {
      const index = this.discounts_added.indexOf(item);
      this.$delete(this.discounts_added, index);
      this.camps.push(item);
      console.log(item);
    }
    // campsSelected(item) {
    //   console.log(item);
    // }
  },
  watch: {
    discoutsItems: {
      handler() {
        setTimeout(() => {
          this.discounts_added = this.form.camps;
          this.$emit("handle_discounts_added", this.discounts_added);
        }, 1000);
        // console.log(value);
      },
      deep: true,
      immediate: true
    }
  }
};
</script>
